var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('button',{staticClass:"accordion text-lg font-semibold"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"panel"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }